"use client";

import { c as _c } from "react/compiler-runtime";
export default function NotFoundContent(t0) {
  const $ = _c(30);
  const {
    appName: t1,
    backControl,
    errorPath,
    messages: t2,
    defaultTitle: t3,
    defaultDescription: t4,
    onRetry
  } = t0;
  const appName = t1 === undefined ? "Catchy" : t1;
  let t5;
  if ($[0] !== t2) {
    t5 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const messages = t5;
  const defaultTitle = t3 === undefined ? "404" : t3;
  const defaultDescription = t4 === undefined ? "Page not found" : t4;
  let t6;
  if ($[2] !== defaultDescription || $[3] !== defaultTitle || $[4] !== errorPath || $[5] !== messages || $[6] !== onRetry) {
    const getErrorMessage = () => {
      switch (errorPath) {
        case "stop":
          {
            return ["This stop is not available", messages.stop || "This stop either doesn\u2019t exist or is not available in the current feed.", null, null];
          }
        case "trip":
          {
            return ["Unable to get trip information.", messages.trip || "This can be caused by Catchy using outdated or incomplete data.", onRetry, "Retry"];
          }
        default:
          {
            return [defaultTitle, defaultDescription, null, null];
          }
      }
    };
    t6 = getErrorMessage();
    $[2] = defaultDescription;
    $[3] = defaultTitle;
    $[4] = errorPath;
    $[5] = messages;
    $[6] = onRetry;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const [title, desc, action, buttonText] = t6;
  const pageTitle = `${title} - ${appName}`;
  let t7;
  if ($[8] !== backControl) {
    t7 = <div className="row sticky top-0 z-20 mb-2 flex justify-between bg-white px-[20px] pb-2 pt-4 dark:bg-black">{backControl}</div>;
    $[8] = backControl;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== title) {
    t8 = <h1 className="mb-4 text-pretty text-3xl font-semibold" suppressHydrationWarning={true}>{title}</h1>;
    $[10] = title;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== desc) {
    t9 = <p className="mb-8 text-lg" suppressHydrationWarning={true}>{desc}</p>;
    $[12] = desc;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = action || undefined;
  const t11 = `w-full rounded-full bg-blue-500 py-2 font-semibold text-white ring-blue-500/50 focus:outline-none focus-visible:ring sm:w-32 ${action ? "" : "hidden"}`;
  const t12 = !action;
  const t13 = action ? undefined : -1;
  let t14;
  if ($[14] !== buttonText || $[15] !== t10 || $[16] !== t11 || $[17] !== t12 || $[18] !== t13) {
    t14 = <div suppressHydrationWarning={true}><button onClick={t10} className={t11} aria-hidden={t12} suppressHydrationWarning={true} tabIndex={t13}>{buttonText}</button></div>;
    $[14] = buttonText;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t14 || $[21] !== t8 || $[22] !== t9) {
    t15 = <div className="px-[20px]">{t8}{t9}{t14}</div>;
    $[20] = t14;
    $[21] = t8;
    $[22] = t9;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== pageTitle) {
    t16 = <span className="sr-only" suppressHydrationWarning={true}>{pageTitle}</span>;
    $[24] = pageTitle;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t15 || $[27] !== t16 || $[28] !== t7) {
    t17 = <div className="min-h-screen bg-white font-body text-zinc-900 antialiased dark:bg-black dark:text-white">{t7}{t15}{t16}</div>;
    $[26] = t15;
    $[27] = t16;
    $[28] = t7;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  return t17;
}